import React, { useState } from 'react';
import { DayPickerProps, useDayPicker, useActiveModifiers } from 'react-day-picker-for-new-calendar';

import { Typography } from '../../Typography';
import { Button2 } from '../../Button2';
import { RedDot } from '../RedDot';


const checkIsSelected = (date: Date, selected?: Date) => {
    if (!selected)
        return false;

    return selected.getDate() === date.getDate() &&
    selected.getMonth() === date.getMonth() &&
    selected.getFullYear() === date.getFullYear();
};


export const Day: DayPickerProps['components']['Day'] = React.memo(({ date, displayMonth }) => {
    const [isDifferenceDateSelected, setDifferenceDateSelected] = useState(false);

    const { today, selected, onDayClick } = useDayPicker();

    const activeModifiers = useActiveModifiers(date, displayMonth);

    const isSelected = checkIsSelected(date, selected as Date);
    const isTodayDaySelected = checkIsSelected(date, today);

    return (
        <Button2
            variant='secondary'
            onMouseDown={e => onDayClick && onDayClick(date, activeModifiers, e)}
            onClick={() => {
                if (!isSelected)
                    setDifferenceDateSelected(true);
            }}
            sx={({ spacing }) => ({
                width: spacing(8),
                height: spacing(8),
                p: 0,
                minWidth: 0,
                minHeight: 0,
                mt: 0.5,
                color: date.getMonth() === displayMonth.getMonth() ? 'grayscale.shade100' : 'grayscale.shade85',

                ...isSelected && {
                    backgroundColor: 'general.primary50',
                    color: 'grayscale.shade0',

                    '&:not(:focus), &:hover': {
                        backgroundColor: 'general.primary50',
                    },
                },

                '&:focus': {
                    backgroundColor: isDifferenceDateSelected ? 'transparent' : 'general.primary50',
                    color: isDifferenceDateSelected ? 'grayscale.shade100' : 'grayscale.shade0',

                    '&:hover': {
                        backgroundColor: isDifferenceDateSelected && 'grayscale.shade10',
                    },
                },
            })}
        >
            <Typography variant='regularCaption1'>
                {date.getDate()}
                {isTodayDaySelected && <RedDot condition={isSelected} />}
            </Typography>
        </Button2>
    );
});
